import { Container } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import MeldunekSpecificationPage from "../../../../components/WMS/ProductionOrders/MeldunekSpecificationPage"
import ProductionOrderPage from "../../../../components/WMS/ProductionOrders/ProductionOrderPage"

type Search = { meldunek?: string }
type RawSearch = { meldunek?: unknown }

export const Route = createFileRoute("/_layout/WMS/production-orders/$order")({
  component: ProductionOrderDetailPage,
  validateSearch: (search: RawSearch): Search => ({
    meldunek: typeof search.meldunek === "string" ? search.meldunek : undefined,
  }),
})

function ProductionOrderDetailPage() {
  const { order } = Route.useParams()
  const { meldunek } = Route.useSearch()

  return (
    <Container maxW="9xl">
      {meldunek ? (
        <MeldunekSpecificationPage orderId={order} meldunekId={meldunek} />
      ) : (
        <ProductionOrderPage id={order} />
      )}
    </Container>
  )
}
